<template>
    <page>
        <module title="代理礼包详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="礼包名称">{{activityInfo.name}}</c-detail-item>

                    <c-detail-item label="礼包价值">{{activityInfo.total_price.toFixed(2)}}元</c-detail-item>

                    <c-detail-item label="备注">{{activityInfo.remark}}</c-detail-item>

                    <c-detail-item label="活动商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="200"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="日常售价"
                                    name="product_price"
                                    width="80"
                            >
                                <template v-slot="{data}">￥{{parseFloat(data.product_price).toFixed(2)}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="数量"
                                    name="gift_count"
                                    width="80"
                            ></c-table-column>

                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'gift_package_detail',

        props: {
            id: String
        },

        data() {
            return {
                activityInfo: '',
                productList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/gift_package/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.giftPackageProductList;
                    }
                });
            }
        }
    }
</script>